import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _typeof from "@babel/runtime/helpers/typeof";
var _excluded = ["payload"];
var isValidSerializedCommand = function isValidSerializedCommand(cmd) {
  return _typeof(cmd) === 'object' && cmd.type && 'payload' in cmd;
};

/**
 * Содержит информацию о поддерживаемых командах и умеет сериализовать и инстанцировать их
 */
export var CommandFilterRegistry = /*#__PURE__*/function () {
  function CommandFilterRegistry(commandTypes) {
    _classCallCheck(this, CommandFilterRegistry);
    this.commandTypes = commandTypes;
  }
  _createClass(CommandFilterRegistry, [{
    key: "toMsg",
    value: function toMsg(_ref) {
      var type = _ref.type,
        payload = _ref.payload,
        uuid = _ref.uuid;
      return {
        type: type,
        uuid: uuid,
        payload: payload
      };
    }

    // FIXME: outbound, inbound
  }, {
    key: "toCommand",
    value: function toCommand(msg) {
      if (!isValidSerializedCommand(msg)) {
        throw new Error("\u041A\u043E\u043C\u0430\u043D\u0434\u0430 \u0434\u043E\u043B\u0436\u043D\u0430 \u0438\u043C\u0435\u0442\u044C \u0442\u043E\u043B\u044C\u043A\u043E type \u0438 payload, \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u043E:\n ".concat(JSON.stringify(msg, null, 2)));
      }
      var AllowedCommandType = this.commandTypes.find(function (_ref2) {
        var type = _ref2.type;
        return msg.type === type;
      });
      if (!AllowedCommandType) throw new Error("\u041F\u043E\u043B\u0443\u0447\u0435\u043D\u0430 \u043D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u0430\u044F \u043A\u043E\u043C\u0430\u043D\u0434\u0430 ".concat(msg.type));
      var payload = msg.payload,
        meta = _objectWithoutProperties(msg, _excluded);
      return new AllowedCommandType(payload, meta);
    }
  }]);
  return CommandFilterRegistry;
}();